export type ProjectionSpec = {
  kind: 'orthographic' | 'perspective'
  fovDeg: number
  label: string
}

export const PROJECTION_VERTICAL_SPAN = 11.5

export function calculateProjection(value: number): ProjectionSpec {
  const amount = Math.min(100, Math.max(0, value))
  if (amount === 0) {
    return { kind: 'orthographic', fovDeg: 0, label: '平行投影' }
  }

  const fovDeg = 6 + amount * 0.36
  return {
    kind: 'perspective',
    fovDeg,
    label: amount < 40 ? '弱い透視' : '透視投影',
  }
}

export function perspectiveDistanceForSpan(fovDeg: number): number {
  return (PROJECTION_VERTICAL_SPAN / 2) / Math.tan((fovDeg * Math.PI) / 360)
}
